<template>
  <figure class="flex space-x-2 lg:flex-col lg:space-x-0 lg:space-y-2">
    <v-login
      v-if="!isAuthenticated"
      :loginShow="showLogin"
        :facebook-login-route="headerSetupData.facebookLoginRoute"
        :google-login-route="headerSetupData.googleLoginRoute"
      :login-error="headerSetupData.loginError"
      :login-post-route="headerSetupData.loginPostRoute"
      :register-route="headerSetupData.registerRoute"
      :forgot-password-route="headerSetupData.forgotPasswordRoute"
      :csrf-token="headerSetupData.csrfToken"
    >
      <template v-slot:trigger>
        <!-- This will preload the image, avoiding content jumps when dialog opens -->
        <link rel="prefetch" href="/assets/images/hiska-1-new.webp" />
        <a
            @click="show = true"
            class="button button--large !flex"
        >
            <v-icon icon="hand-wave"></v-icon>
            Stopite v stik
        </a>
      </template>
    </v-login>
    <v-lightbox
      :login-route="headerSetupData.loginPostRoute"
      :register-route="headerSetupData.registerRoute"
      :head-class="'border-b'"
      :content-class="'px-4 md:px-8'"
      :foot-class="'justify-center border-t'"
      :is-authenticated="isAuthenticated"
      :show="showListingContactModal"
      v-if="isAuthenticated"
      @close="showListingContactModal = false"
    >
      <template v-slot:trigger>
        <a
          class="button"
          @click="(showListingContactModal = true), (showLogin = false)"
        >
          <v-icon icon="hand-wave"></v-icon>
          <label>Stopite v stik</label>
        </a>
      </template>
      <template v-slot:head>
        <v-icon icon="hand-wave" size="4" class="mr-2.5"></v-icon>
        <label>Stopite v stik</label>
      </template>
      <template v-slot:content>
        <!-- TODO: @jan please fix so if-else will work based on type of listing -->
        <template v-if="isRealestateAgent">
          <!-- Nepremičninski posrednik -->
          <figure class="mb-8 flex max-w-xs items-center gap-4 mx-auto">
            <div class="relative flex">
              <div class="relative">
                <div
                  class="flex h-[72px] w-[72px] items-center justify-center overflow-hidden rounded-full bg-gray-border"
                >
                  <img
                    v-if="agency.elements.imageUrl"
                    class="min-h-full min-w-full max-w-full rounded-full object-contain"
                    :src="agency.elements.imageUrl"
                    alt=""
                  />
                  <img
                    v-else
                    class="min-h-full min-w-full max-w-full rounded-full object-cover"
                    :src="$assetsUrl + '/images/profile_placeholder.png'"
                    alt=""
                  />
                </div>
              </div>
              <div class="relative">
                <!-- -ml-6 -->
                <div
                  class="flex h-[72px] w-[72px] items-center justify-center overflow-hidden rounded-full bg-gray-border"
                >
                  <img
                    v-if="propertyContactPerson.elements.imageUrl"
                    class="min-h-full min-w-full max-w-full rounded-full object-cover"
                    :src="propertyContactPerson.elements.imageUrl"
                    alt=""
                  />
                  <img
                    v-else
                    class="min-h-full min-w-full max-w-full rounded-full object-cover"
                    :src="$assetsUrl + '/images/profile_placeholder.png'"
                    alt=""
                  />
                </div>
                <div
                  class="absolute bottom-0 right-0 flex h-6 w-6 items-center justify-center rounded-full bg-green"
                >
                  <v-icon
                    icon="certificate"
                    class="text-white"
                    size="3.5"
                  ></v-icon>
                </div>
              </div>
            </div>
            <div>
              <div class="text-heading-3-desktop text-black-78">
                {{
                  propertyContactPerson.elements.Vorname +
                  " " +
                  propertyContactPerson.elements.Name
                }}
              </div>
              <div class="mt-1 text-small-text-regular text-black-40">
                Nepremičninski posrednik
              </div>
              <div class="mt-4 flex items-center gap-2">
                <v-icon icon="captive-portal" class="text-black-40"></v-icon>
                <div class="text-small-text-medium text-black-40">
                  {{ propertyContactPerson.elements.Zusatz1 }}
                </div>
              </div>
            </div>
          </figure>
          <figure class="mb-8 flex max-w-xs flex-col gap-6 mx-auto">
            <section class="flex gap-[10px]" v-if="umbrellaOrganization">
              <v-icon icon="business-chip"></v-icon>
              <div>
                <div class="mb-2 text-body-bold text-black-78">
                  Krovna nepremičninska agencija
                </div>
                <div class="text-small-text-medium text-black-40">
                  {{ umbrellaOrganization.elements.umbrellaOrganization }}
                </div>
              </div>
            </section>
            <section class="flex gap-[10px]" v-if="agency">
              <v-icon icon="work"></v-icon>
              <div>
                <div class="mb-2 text-body-bold text-black-78">
                  Nepremičninska agencija
                </div>
                <div class="text-small-text-medium text-black-40">
                  {{ agency.elements.Zusatz1 }}
                </div>
              </div>
            </section>
            <section
              class="flex gap-[10px]"
              v-if="showContactPhone || showContactEmail"
            >
              <v-icon icon="contact-emergency"></v-icon>
              <div>
                <div class="mb-2 text-body-bold text-black-78">
                  Kontaktni podatki
                </div>
                <div
                  v-if="showContactPhone"
                  class="mb-2 flex gap-2 text-small-text-medium text-black-40"
                >
                  <v-icon icon="call"></v-icon>
                  <div>{{ propertyContactPerson.elements.Telefon1 }}</div>
                </div>
                <div
                  v-if="showContactEmail"
                  class="flex gap-2 text-small-text-medium text-black-40"
                >
                  <v-icon icon="outgoing-mail"></v-icon>
                  <div>{{ propertyContactPerson.elements.Email }}</div>
                </div>
              </div>
            </section>
          </figure>
        </template>
        <template v-else>
          <!-- Preverjena ponudba fizične osebe -->
          <figure class="mb-8 flex max-w-xs items-center gap-4 mx-auto">
            <div class="relative">
              <div
                class="flex h-[72px] w-[72px] items-center justify-center overflow-hidden rounded-full bg-gray-border"
              >
                <img
                  v-if="propertyContactPerson.elements.imageUrl"
                  class="min-h-full min-w-full max-w-full rounded-full object-cover"
                  :src="propertyContactPerson.elements.imageUrl"
                  alt=""
                />
                <img
                  v-else
                  class="min-h-full min-w-full max-w-full rounded-full object-cover"
                  :src="$assetsUrl + '/images/profile_placeholder.png'"
                  alt=""
                />
              </div>
              <div
                class="absolute bottom-0 right-0 flex h-6 w-6 items-center justify-center rounded-full bg-green"
              >
                <v-icon
                  icon="certificate"
                  class="text-white"
                  size="3.5"
                ></v-icon>
              </div>
            </div>
            <div>
              <div class="text-heading-3-desktop text-black-78">
                {{
                  propertyContactPerson.elements.Vorname +
                  " " +
                  propertyContactPerson.elements.Name
                }}
              </div>
              <div class="mt-1 text-small-text-regular text-black-40">
                Preverjena ponudba fizične osebe
              </div>
            </div>
          </figure>
          <figure
            v-if="showContactPhone || showContactEmail"
            class="mb-8 flex max-w-xs flex-col gap-6 mx-auto"
          >
            <section class="flex gap-[10px]">
              <v-icon icon="contact-emergency"></v-icon>
              <div>
                <div class="mb-2 text-body-bold text-black-78">
                  Kontaktni podatki
                </div>
                <div
                  v-if="showContactPhone"
                  class="mb-2 flex gap-2 text-small-text-medium text-black-40"
                >
                  <v-icon icon="call"></v-icon>
                  <div>{{ propertyContactPerson.elements.Telefon1 }}</div>
                </div>
                <div
                  v-if="showContactEmail"
                  class="flex gap-2 text-small-text-medium text-black-40"
                >
                  <v-icon icon="outgoing-mail"></v-icon>
                  <div>{{ propertyContactPerson.elements.Email }}</div>
                </div>
              </div>
            </section>
          </figure>
        </template>
        <hr class="my-11" />
        <template v-if="isAuthenticated">
          <template v-if="formSent">
            <figure
              class="flex min-h-32 items-center justify-center gap-2 text-green"
            >
              <v-icon icon="check-circle"></v-icon>
              <div class="text-icon-text-medium">
                Uspešno ste kontaktirali ponudnika nepremičnine
              </div>
            </figure>
          </template>
          <template v-else>
            <figure class="mb-6 flex items-center justify-center gap-[10px]">
              <v-icon icon="user-chat" size="4"></v-icon>
              <div class="text-body-medium-button">
                Pošljite povpraševanje za to nepremičnino
              </div>
            </figure>
            <figure class="mb-6 flex max-w-xs flex-col gap-6 mx-auto">
              <p class="mt-2 text-center text-small-text-regular text-black-40">
                V vsakem poslanem povpraševanju se bodo po elektrosnki pošti
                poslali vaši kontakntni podakti posredniku nepremičnine.
              </p>
            </figure>
            <figure class="mb-6 flex max-w-xs flex-col gap-6 mx-auto">
              <v-checkbox
                :id="'user_agreement'"
                :name="'user_agreement'"
                :label="'Strinjam se s tem, da se moji podatki posredujejo posredniku nepremičnine.'"
                checkbox-position="right"
                :value="'true'"
                :checked="userAgreement"
                @vchanged="userAgreement = !userAgreement"
              ></v-checkbox>
            </figure>
          </template>
        </template>
        <template v-else>
          <figure class="mb-6 flex items-center justify-center gap-[10px]">
            <v-icon icon="user-chat" size="4"></v-icon>
            <div class="text-body-medium-button">
              Pošljite povpraševanje za to nepremičnino
            </div>
          </figure>
          <p class="mt-2 text-center text-small-text-regular text-black-40">
            Za povpraševanje morate biti prijavljeni
          </p>
          <div class="mt-8 flex items-center justify-center">
            <a
              class="button button--form button--white"
              @click="(showListingContactModal = false), (showLogin = true)"
            >
              <v-icon icon="arrow-right-inside-box"></v-icon>
              <span>Prijavi se</span>
            </a>
          </div>
        </template>
      </template>
      <template v-slot:foot>
        <template v-if="isAuthenticated">
          <template v-if="formSent">
            <a
              class="button button--form"
              @click="showListingContactModal = false"
            >
              <label>Zapri</label>
              <v-icon icon="close"></v-icon>
            </a>
          </template>
          <template v-else>
            <a
              :class="[
                'button button--form',
                !userAgreement ? 'disabled text-black hover:bg-inherit' : '',
              ]"
              @click="sendInquiry()"
            >
              <label>Pošljite</label>
              <v-icon icon="send"></v-icon>
            </a>
          </template>
        </template>
      </template>
    </v-lightbox>
  </figure>
</template>

<script>
export default {
  props: {
    isAuthenticated: {
      type: Boolean,
      default: false,
    },
    headerSetupData: {
      type: Object,
      required: true,
    },
    property: {
      type: Object,
      required: true,
    },
    propertyContactPerson: {
      type: Object,
      required: true,
    },
    agency: {
      type: Object,
      required: false,
      default: null,
    },
    umbrellaOrganization: {
      type: Object,
      required: false,
      default: null,
    },
    user: {
      type: [Object, null],
      required: true,
    },
    showContactEmail: {
      type: Boolean,
      required: false,
      default: true,
    },
    showContactPhone: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  mounted() {},
  data() {
    return {
      formSent: false,
      userAgreement: false,
      showListingContactModal: false,
      showLogin: false,
    };
  },
  computed: {
    isRealestateAgent() {
      if (this.agency !== null) {
        return true;
      }

      return false;
    },
  },
  methods: {
    sendInquiry() {
      if (!this.userAgreement) return; // If user doesn't agree don't do action

      let data = {
        rent_or_buy: this.property.elements.vermarktungsart,
        property_on_office_id: this.property.id,
        property_contact_person_on_office_id: this.propertyContactPerson.id,
        person_contacting_on_office_id: this.user.on_office_id,
      };

      let config = {
        headers: {
          "X-CSRF-TOKEN": this.$csrfToken,
        },
      };

      axios.post(this.headerSetupData.listingInquiry, data, config).then(
        (response) => {
          this.formSent = true;
        },
        (error) => {
          console.log(error);
        }
      );
    },
  },
};
</script>
